import get from 'lodash/get';
import {
  addMarketplaceEntities,
  getListingsEntities,
} from '../../ducks/marketplaceData.duck';
import { fetchAirplanesMetadata } from '../../modules/airplanes/airplanes.creator';

import { restApiService } from '../../services/services';
import {
  handleAxiosResponse,
} from '../../util/apiHelpers';
import { storableError } from '../../util/errors';
import { getImagesParams } from '../../util/listing';
import { $currentUserState } from '../../ducks/user.duck';
import { getDealerId, getUserUUID } from '../../util/user.path';

export const LISTINGS_BY_AUTHOR_REQUEST = 'app/DashboardPage/LISTINGS_BY_AUTHOR_REQUEST';
export const LISTINGS_BY_AUTHOR_SUCCESS = 'app/DashboardPage/LISTINGS_BY_AUTHOR_SUCCESS';
export const LISTINGS_BY_AUTHOR_ERROR = 'app/DashboardPage/LISTINGS_BY_AUTHOR_ERROR';

export const CHARTS_DATA_REQUEST = 'app/DashboardPage/CHARTS_DATA_REQUEST';
export const CHARTS_DATA_SUCCESS = 'app/DashboardPage/CHARTS_DATA_SUCCESS';
export const CHARTS_DATA_ERROR = 'app/DashboardPage/CHARTS_DATA_ERROR';

export const TOP_LISTINGS_BY_VIEW_REQUEST = 'app/DashboardPage/TOP_LISTINGS_BY_VIEW_REQUEST';
export const TOP_LISTINGS_BY_VIEW_SUCCESS = 'app/DashboardPage/TOP_LISTINGS_BY_VIEW_SUCCESS';
export const TOP_LISTINGS_BY_VIEW_ERROR = 'app/DashboardPage/TOP_LISTINGS_BY_VIEW_ERROR';

export const TOP_LISTINGS_BY_LEADS_REQUEST = 'app/DashboardPage/TOP_LISTINGS_BY_LEADS_REQUEST';
export const TOP_LISTINGS_BY_LEADS_SUCCESS = 'app/DashboardPage/TOP_LISTINGS_BY_LEADS_SUCCESS';
export const TOP_LISTINGS_BY_LEADS_ERROR = 'app/DashboardPage/TOP_LISTINGS_BY_LEADS_ERROR';

const initialChartsData = {
  'Clicks on the number': [],
  messages: [],
  views: [],
  saves: [],
};

const initialState = {
  listingsByAuthor: [],
  listingsByAuthorIsPending: false,
  listingsByAuthorError: null,
  chartsData: initialChartsData,
  chartsDataIsPending: false,
  chartsDataError: null,
  topListingsByView: [],
  topListingsByViewIsPending: false,
  topListingsByViewError: null,
  topListingsByLeads: [],
  topListingsByLeadsIsPending: false,
  topListingsByLeadsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case LISTINGS_BY_AUTHOR_REQUEST:
      return {
        ...state,
        listingsByAuthorIsPending: true,
        listingsByAuthorError: null,
      };

    case LISTINGS_BY_AUTHOR_SUCCESS:
      return {
        ...state,
        listingsByAuthorIsPending: false,
        listingsByAuthor: payload,
      };

    case LISTINGS_BY_AUTHOR_ERROR:
      return {
        ...state,
        listingsByAuthorIsPending: false,
        listingsByAuthorError: payload,
      };

    case CHARTS_DATA_REQUEST:
      return {
        ...state,
        chartsDataIsPending: true,
        chartsDataError: null,
      };

    case CHARTS_DATA_SUCCESS:
      return {
        ...state,
        chartsDataIsPending: false,
        chartsData: payload,
      };

    case CHARTS_DATA_ERROR:
      return {
        ...state,
        chartsDataIsPending: false,
        chartsDataError: payload,
      };

    case TOP_LISTINGS_BY_VIEW_REQUEST:
      return {
        ...state,
        topListingsByViewIsPending: true,
        topListingsByViewError: null,
      };

    case TOP_LISTINGS_BY_VIEW_SUCCESS:
      return {
        ...state,
        topListingsByViewIsPending: false,
        topListingsByView: payload,
      };

    case TOP_LISTINGS_BY_VIEW_ERROR:
      return {
        ...state,
        topListingsByViewIsPending: false,
        topListingsByViewError: payload,
      };

    case TOP_LISTINGS_BY_LEADS_REQUEST:
      return {
        ...state,
        topListingsByLeadsIsPending: true,
        topListingsByLeadsError: null,
      };

    case TOP_LISTINGS_BY_LEADS_SUCCESS:
      return {
        ...state,
        topListingsByLeadsIsPending: false,
        topListingsByLeads: payload,
      };

    case TOP_LISTINGS_BY_LEADS_ERROR:
      return {
        ...state,
        topListingsByLeadsIsPending: false,
        topListingsByLeadsError: payload,
      };

    default: return state;
  }
}

export const listingsByAuthorRequest = () => ({
  type: LISTINGS_BY_AUTHOR_REQUEST,
});

export const listingsByAuthorSuccess = payload => ({
  type: LISTINGS_BY_AUTHOR_SUCCESS,
  payload,
});

export const listingsByAuthorError = error => ({
  type: LISTINGS_BY_AUTHOR_ERROR,
  payload: error,
});

export const chartsDataRequest = () => ({
  type: CHARTS_DATA_REQUEST,
});

export const chartsDataSuccess = payload => ({
  type: CHARTS_DATA_SUCCESS,
  payload,
});

export const chartsDataError = error => ({
  type: CHARTS_DATA_ERROR,
  payload: error,
});

export const topListingsByViewRequest = () => ({
  type: TOP_LISTINGS_BY_VIEW_REQUEST,
});

export const topListingsByViewSuccess = payload => ({
  type: TOP_LISTINGS_BY_VIEW_SUCCESS,
  payload,
});

export const topListingsByViewError = error => ({
  type: TOP_LISTINGS_BY_LEADS_ERROR,
  payload: error,
});

export const topListingsByLeadsRequest = () => ({
  type: TOP_LISTINGS_BY_LEADS_REQUEST,
});

export const topListingsByLeadsSuccess = payload => ({
  type: TOP_LISTINGS_BY_LEADS_SUCCESS,
  payload,
});

export const topListingsByLeadsError = error => ({
  type: TOP_LISTINGS_BY_LEADS_ERROR,
  payload: error,
});

// ================ Selectors ============= //

const $subState = state => {
  return state.DashboardPage;
};

export const $topListingsByViewIsPending = state => {
  const subState = $subState(state);
  return subState.topListingsByViewIsPending;
}

export const $topListingsByLeadsIsPending = state => {
  const subState = $subState(state);
  return subState.topListingsByLeadsIsPending;
}

export const $listingsByAuthorState = state => {
  const subState = $subState(state);
  return {
    data: subState.listingsByAuthor,
    inProgress: subState.listingsByAuthorIsPending,
    error: subState.listingsByAuthorError
  };
}

export const $chartsDataState = state => {
  const subState = $subState(state);
  return {
    data: subState.chartsData,
    inProgress: subState.chartsDataIsPending,
    error: subState.chartsDataError,
  }
}

export const $topListingsByViewState = state => {
  const subState = $subState(state);
  return getListingsEntities(state)(subState.topListingsByView);
};

export const $topListingsByLeadsState = state => {
  const subState = $subState(state);
  return getListingsEntities(state)(subState.topListingsByLeads);
};

// ================ Thunks ================ //

export const getChartsData = (authorId, datesRange) => (dispatch, getState, sdk) =>  {
  dispatch(chartsDataRequest());

  return restApiService.publicInstance
    .getRaw(`/listingCounters/dashboardChartsData`, {params: { authorId, datesRange }})
    .then(handleAxiosResponse)
    .then(response => {
      dispatch(chartsDataSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(chartsDataError(storableError(e)));
      throw e;
    });
}

export const getListingsByAuthor = () => (dispatch) => {
  dispatch(listingsByAuthorRequest());

  const params = {
    'fields.listing': ['title', 'createdAt', 'publishedAt'],
  }

  return restApiService.secureInstance
    .getRaw(`brokers/get-dealer-listings`, { params })
    .then(async response => {
      dispatch(listingsByAuthorSuccess(response.data.data));
      return response;
    })
    .catch(e => {
      dispatch(listingsByAuthorError(storableError(e)));
      throw e;
    });
};

export const getChartsDataById = (listingId, datesRange) => (dispatch, getState, sdk) =>  {
  dispatch(chartsDataRequest());

  return restApiService.publicInstance
    .getRaw(`/listingCounters/dashboardChartsDataById`, {params: { listingId, datesRange }})
    .then(handleAxiosResponse)
    .then(response => {
      dispatch(chartsDataSuccess(response));
    })
    .catch(e => {
      dispatch(chartsDataError(storableError(e)));
      throw e;
    });
}

const getTopListingsParams = (metaCount, state) => {
  const currentUser = $currentUserState(state).currentUser;
  const userId = getUserUUID(currentUser);
  const dealerId = getDealerId(currentUser);
  const authorId = dealerId || userId;
  return {
    page: 1,
    perPage: 4,
    authorId,
    sort: metaCount,
    include: ['images'],
    'fields.listing': ['title', 'geolocation', 'price', 'publicData', 'metadata'],
    ...getImagesParams(),
  };
}

export const getTopListingsByView = () => (dispatch, getState, sdk) => {
  dispatch(topListingsByViewRequest());
  const params = getTopListingsParams('meta_pageViewCount', getState());
  return sdk.listings
    .query(params)
    .then(async resp => {
      const data = get(resp, 'data.data', []);
      const ids = data.map(i => i.id);

      dispatch(addMarketplaceEntities(resp));
      dispatch(fetchAirplanesMetadata(data));
      dispatch(topListingsByViewSuccess(ids));

      return resp;
    })
    .catch(e => {
      dispatch(topListingsByViewError(storableError(e)));
      throw e;
    });

};

export const getTopListingsByLeads = () => (dispatch, getState, sdk) => {
  dispatch(topListingsByLeadsRequest());
  const params = getTopListingsParams('meta_totalCallsMessagesCount', getState());
  return sdk.listings
    .query(params)
    .then(async resp => {
      const data = get(resp, 'data.data', []);
      const ids = data.map(i => i.id);

      dispatch(addMarketplaceEntities(resp));
      dispatch(fetchAirplanesMetadata(data));
      dispatch(topListingsByLeadsSuccess(ids));

      return resp;
    })
    .catch(e => {
      dispatch(topListingsByLeadsError(storableError(e)));
      throw e;
    });
};

export const loadData = () => dispatch =>  {
  return Promise.all([
    dispatch(getListingsByAuthor()),
    dispatch(getTopListingsByView()),
    dispatch(getTopListingsByLeads()),
  ]);
};
